import * as ActionTypes from "../ActionTypes";

export const GetMprRequestsAction = (params) => {
    return {
        type: ActionTypes.ATS_MPR_REQUESTS_GET_REQUEST,
        params
    };
};

export const UpsertMprRequestsAction = (params, callback) => {
    return {
        type: ActionTypes.ATS_MPR_REQUESTS_UPSERT_REQUEST,
        params,
        callback
    };
};

export const GetApproverMprRequestsAction = (params) => {
    return {
        type: ActionTypes.ATS_APPROVER_MPR_REQUESTS_GET_REQUEST,
        params
    };
};

export const UpdateApproverMprRequestsAction = (params, callback) => {
    return {
        type: ActionTypes.ATS_APPROVER_MPR_REQUESTS_UPDATE_REQUEST,
        params,
        callback
    };
};

export const GetMprDashboardAction = (params) => {
    return {
        type: ActionTypes.ATS_MPR_DASHBOARD_GET_REQUEST,
        params
    };
};

export const GetMprDashboardCardsAction = (params) => {
    return {
        type: ActionTypes.ATS_MPR_DASHBOARD_CARDS_GET_REQUEST,
        params
    };
};
